import  RouteConstants  from "@/app/core/RouteConstants";

export default class Constants {
  static LIMIT_LOAD_FILES=10000000;

  static SPECIALITY_CONSULTATION = 1;
  static SPECIALITY_IMAGE = 2;
  static SPECIALITY_LABORATORY = 3;
  static SPECIALITY_DENTAL = 4;
  static SPECIALITY_OPTOMETRY = 5;
  static SPECIALITY_AUDIOMETRY = 6;
  static SPECIALITY_PSYCHOLOGY = 7;
  static SPECIALITY_COLPOSCOPY = 8
  static SPECIALITY_TELEMEDICINE = 9;


  //Status appointment
  static APPOINTMENT_STATUS_PENDING = 1;
  static APPOINTMENT_STATUS_REAGENT = 2;
  static APPOINTMENT_STATUS_ATTEND = 3;
  static APPOINTMENT_STATUS_CANCEL = 4;
  static APPOINTMENT_STATUS_NO_PRESENT = 5;
  static APPOINTMENT_STATUS_NOTIFIED = 6;
  static APPOINTMENT_STATUS_TO_ATTEND = 7;

  //TYPE ANSWER
  static ANSWER_TYPE_OPEN = 1;
  static ANSWER_TYPE_CLOSED = 2;
  static ANSWER_TYPE_MULTIPLE = 3;
  static ANSWER_TYPE_COMBINED = 4;

  //TYPE DATA ANSWER
  static ANSWER_TYPE_DATA_TEXT = 1;
  static ANSWER_TYPE_DATA_NUMBER = 2;
  static ANSWER_TYPE_DATA_EMAIL = 3;
  static ANSWER_TYPE_DATA_DATE = 4;
  static ANSWER_TYPE_DATA_DATE_TIME = 5;
  static ANSWER_TYPE_DATA_LONG_TEXT = 6;
  static ANSWER_TYPE_DATA_CHECKBOX = 7;
  static ANSWER_TYPE_DATA_CIRCULAR = 8;

  static TYPE_REPORT_STUDY_PENDING = 1;
  static TYPE_REPORT_STUDY_TO_CLOSE = 2;
  static TYPE_REPORT_STUDY_HISTORY = 3;

  static STATUS_PRESCRIPTION_DISPENSED = 2;
  static STATUS_PRESCRIPTION_CANCELLED = 3;

  /**WEB SERVICES */
  static HTTPMETHOD_LIST = [{
      text: "GET",
      value: "GET"
    },
    {
      text: "POST",
      value: "POST"
    },
    {
      text: "PUT",
      value: "PUT"
    },
    {
      text: "DELETE",
      value: "DELETE"
    },
    {
      text: "HEAD",
      value: "HEAD"
    },
    {
      text: "CONNECT",
      value: "CONNECT"
    },
    {
      text: "OPTIONS",
      value: "OPTIONS"
    },
    {
      text: "PATCH",
      value: "PATCH"
    },
  ];

  static CLEAR_ICON = "mdi-eraser";
  static ALERT_ICON = "mdi-alert";
  static VALID_ICON = "mdi-check";
  
  /**DENTAL */
  static SEALING_PITS_CRACKS = "SELLADO DE FOSETAS Y FISURAS";
  static CURE_CARE = "Atención curativa";

  static STUDY_TOSTART = {
    status: 1,
    name: "Por Comenzar"
  };
  static STUDY_INPROCESS = {
    status: 2,
    name: "En Proceso"
  };
  static STUDY_CLOSING = {
    status: 3,
    name: "Por Cerrar"
  };

  static statusNameStudies = [{
      status: 1,
      name: "Por Comenzar",
      modules: []
    },
    {
      status: 2,
      name: "En Proceso",
      modules: []
    },
    {
      status: 3,
      name: "Por Cerrar",
      modules: []
    },
    {
      status: 4,
      name: "Cancelado o Descartado",
      color: "red",
      modules: []
    },
    {
      status: 5,
      name: "Por Interpretar",
      color: "blue",
      dark: true,
      modules: [RouteConstants.IMAGE_HISTORY.name]
    },
    {
      status: 6,
      name: "Interpretado",
      color: "green",
      dark: true,
      modules: [RouteConstants.IMAGE_HISTORY.name]
    },
    {
      status: 7,
      name: "Entregado",
      modules: []
    },
    {
      status: 8,
      name: "Emergencia",
      modules: []
    },
    {
      status: 13,
      name: "Validado",
      modules: []
    },
    {
      status: 14,
      name: "Verificación de imagen",
      color: "orange",
      modules: [RouteConstants.IMAGE_HISTORY.name]
    },
    {
      status: 15,
      name: "En interpretación",
      color: "orange",
      modules: [RouteConstants.IMAGE_HISTORY.name]
    },
  ];

  static CATEGORY_GLOMERULAR = 'Tasa de filtración glomerular';
  static CATEGORY_CREATININA = 'Creatinina';
  static WEIGHT_VITAL_SIGN = 'Peso';

  //INTERPRETATION STATUS
  static STUDY_INTERPRETATING_STATUS = 15;
  static STUDY_INTERPRETATED_STATUS = 6;

  //CANCEL FROM SOMATOMETRY 
  static FROM_SOMATOMETRY_STATUS = 0;
  static FROM_SOMATOMETRY_APPOINTMENT_STATUS = 4;

  static SCHOOL_GRADES = [
    { name:'Preescolar' },
    { name:'Primaria' },
    { name:'Secundaria' },
    { name:'Bachillerato'},
    { name:'Licenciatura'},
  ];

  static IS_MOMMOGRAPHY = (aWord) => {
    return ['mastografia', 'mastografía'].some(wordMasto => `${aWord}`.toLowerCase().includes(wordMasto));
  }


}